import { ModuleList } from '../../shared/analytics/module-list';
import { pagesConfig } from '../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import OwnershipTransferLogsPage from './ownership-transfer-logs-page';

export default function OwnershipTransferLogsGridPage() {
  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.drive.name },
        { label: pagesConfig.ownershipTransferLogs.name },
      ]}
      bookmarkKey={pagesConfig.ownershipTransferLogs.value}
    >
      <OwnershipTransferLogsPage />
    </SimpleBreadcrumbsPage>
  );
}
